import { Link } from "react-router-dom";
import { Mail, MessageCircle } from "lucide-react";
import { Separator } from "@/components/ui/separator";

const footerLinks = [
  { name: "About Bikram", path: "/about" },
  { name: "The Work", path: "/the-work" },
  { name: "Events", path: "/events" },
  { name: "Dialogue", path: "/dialogue" },
  { name: "Contact", path: "/contact" },
];

const socialLinks = [
  { name: "LinkedIn", url: "https://www.linkedin.com/in/bikramjhaa" },
  { name: "Facebook", url: "https://www.facebook.com/bikramadvait" },
  { name: "Instagram", url: "https://www.instagram.com/bikramjha_/" },
  { name: "X", url: "https://x.com/bikramjha_" },
  { name: "Medium", url: "https://medium.com/@bikramjha_" },
  { name: "YouTube", url: "https://www.youtube.com/@bikram_jha" },
];

export function Footer() {
  return (
    <footer className="border-t border-[hsl(48,12%,88%)]" style={{ backgroundColor: "#F5F5F0" }} data-testid="footer">
      <div className="max-w-screen-xl mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About */}
          <div>
            <h3 className="font-accent italic text-2xl mb-4 text-foreground">Bikram Jha</h3>
            <p className="font-body text-sm text-muted-foreground leading-relaxed max-w-xs">
              Sharing the gift that belongs to all.
            </p>
          </div>

          {/* Navigate */}
          <div>
            <h4 className="font-body text-xs tracking-[0.2em] uppercase text-muted-foreground mb-6">Navigate</h4>
            <div className="flex flex-col gap-3">
              {footerLinks.map((link) => (
                <Link key={link.path} to={link.path} className="font-body text-sm text-muted-foreground hover:text-foreground transition-colors duration-300">{link.name}</Link>
              ))}
            </div>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-body text-xs tracking-[0.2em] uppercase text-muted-foreground mb-6">Connect</h4>
            <a href="mailto:bikram@jdf.org.in" className="flex items-center gap-2 font-body text-sm text-muted-foreground hover:text-foreground transition-colors duration-300 mb-3" data-testid="footer-email">
              <Mail size={14} strokeWidth={1.5} />
              bikram@jdf.org.in
            </a>
            <a href="https://wa.me/919693647913" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 font-body text-sm text-muted-foreground hover:text-foreground transition-colors duration-300 mb-5" data-testid="footer-whatsapp">
              <MessageCircle size={14} strokeWidth={1.5} />
              WhatsApp
            </a>
            <div className="flex flex-wrap gap-x-5 gap-y-2">
              {socialLinks.map((s) => (
                <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer" className="font-body text-xs text-muted-foreground hover:text-foreground transition-colors duration-300" data-testid={`footer-${s.name.toLowerCase()}`}>{s.name}</a>
              ))}
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-body text-xs tracking-[0.2em] uppercase text-muted-foreground mb-6">Newsletter</h4>
            <p className="font-body text-sm text-muted-foreground leading-relaxed mb-4">
              Writings on inquiry, awareness, and living. Subscribe to receive them in your inbox.
            </p>
            <div className="overflow-hidden" style={{ maxHeight: "160px" }}>
              <iframe
                src="https://bikramjha.substack.com/embed"
                width="100%"
                height="160"
                style={{ border: "none", background: "transparent" }}
                frameBorder="0"
                scrolling="no"
                title="Subscribe to newsletter"
                data-testid="substack-embed"
              />
            </div>
          </div>
        </div>

        <Separator className="my-10" style={{ backgroundColor: "#E5E4DE" }} />
        <p className="font-body text-xs text-muted-foreground/50 text-center tracking-wide">
          Managed by Jeevan Darshan Foundation (JDF)
        </p>
      </div>
    </footer>
  );
}
